export enum ToastType {
    SUCCESS = 'success',
    ERROR = 'error',
}

export enum ToastPosition {
    TOP = 'top',
    BOTTOM = 'bottom',
}
